export default __webpack_public_path__ + "img/3fe90a4cf4015b6ebc1b656667620acc.svg";